<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-12 16:07:55
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <div class="header">
        <div class="title">基本信息 Basic information</div>
        <div>
          <el-button type="primary" v-if="uploads">
            <i class="iconfont iconshangchuan"></i>上传附件分享地址
          </el-button>
          <el-button type="primary" @click="imports = true">
            <i class="iconfont icondaochu"></i>导出报名表
          </el-button>
        </div>
      </div>
      <div class="cont">
        <ul class="part1">
          <li>
            <el-input placeholder="请输入内容" v-model="basce.name">
              <template slot="prepend">合唱团名称：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.country">
              <template slot="prepend">国家：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.enname">
              <template slot="prepend">Name of the group：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.encountry">
              <template slot="prepend">Country：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.street">
              <template slot="prepend">通讯地址：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.city">
              <template slot="prepend">省/城市：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.zip">
              <template slot="prepend">州/省 邮政编码：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.enstreet">
              <template slot="prepend">Street：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.encity">
              <template slot="prepend">City:</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.enzip">
              <template slot="prepend">State/Province & Zip Code：</template>
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="（国家代码-城市区号-电话号码）"
              v-model="basce.phone"
            >
              <template slot="prepend">电话：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.fax">
              <template slot="prepend">传真：</template>
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="Country code / area code / number"
              v-model="basce.enphone"
            >
              <template slot="prepend">Phone：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.enfax">
              <template slot="prepend">Fax：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.email">
              <template slot="prepend">电子邮箱：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.enemail">
              <template slot="prepend">E-mail：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.website">
              <template slot="prepend">合唱团网址：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.enwebsite">
              <template slot="prepend">Website：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.year">
              <template slot="prepend">合唱团成立年份：</template>
            </el-input>
          </li>
          <li>
            <el-input placeholder="请输入内容" v-model="basce.enyear">
              <template slot="prepend">Year choir was founded：</template>
            </el-input>
          </li>
        </ul>
        <!-- <contact></contact>
        <conductor></conductor>
        <part4></part4>
        <part5></part5>
        <part6></part6>
        <part7></part7>
        <part8></part8>
        <part9></part9>
        <part10></part10>
        <part11></part11>
        <part12></part12> -->
        <contact ref="Contactperson" :Contactpersonh="Contactperson"></contact>
        <conductor ref="Conductor" :Conductorh="Conductor"></conductor>
        <part4 ref="conductors" :conductorsh="conductors"></part4>
        <part5 ref="organizations" :organizationsh="organizations"></part5>
        <part6 ref="Organizainfor" :Organizainforh="Organizainfor"></part6>
        <part7 ref="Lengthstay" :Lengthstayh="Lengthstay"></part7>
        <part8 ref="numberrooms" :numberroomsh="numberrooms"></part8>
        <part9 ref="Transportation" :Transportationh="Transportation"></part9>
        <part10 ref="activities" :activitiesh="activities"></part10>
        <part11 ref="documents" :documentsh="documents"></part11>
        <part12 ref="Scores" :Scoresh="Scores"></part12>
        <div class="bottoms">
          <!-- dialogTableVisible = true -->
          <el-button type="primary" @click="dialogTableVisible = true"
            >提交</el-button
          >
          <el-button type="primary" @click="submits(0)">保存</el-button>
          <!-- dialogVisible = true -->
          <el-button>取消</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="特别提示" :visible.sync="dialogTableVisible">
      <p class="tip">
        注：请确认信息是否正确的，
        <br />确认提交之后将无法修改报名信息！
      </p>
      <div class="btnbox">
        <button @click="submits(1)">确定</button>
        <button class="info" @click="dialogTableVisible = false">取消</button>
      </div>
    </el-dialog>
    <el-dialog title="特别提示" :visible.sync="imports">
      <p class="tip">请确认是否导出</p>
      <div class="btnboxs">
        <button @click="(uploads = true), (imports = false)">确定</button>
        <button class="info" @click="imports = false">取消</button>
      </div>
    </el-dialog>
    <el-dialog title="特别提示" :visible.sync="dialogVisible">
      <span>
        已保存成功
        <br />3 秒后返回报名界面
      </span>
    </el-dialog>
  </div>
</template>

<script>
import contact from "../formbox/contact";
import conductor from "../formbox/conductor";
import part4 from "../formbox/part4";
import part5 from "../formbox/part5";
import part6 from "../formbox/part6";
import part7 from "../formbox/part7";
import part8 from "../formbox/part8";
import part9 from "../formbox/part9";
import part10 from "../formbox/part10";
import part11 from "../formbox/part11";
import part12 from "../formbox/part12";
import {
  apply_detail,
  applysubmit,
  applySubmitTemplate1,
  template_file,
  upload,
  applyupdate,
} from "@/api/file"; // 接口导入
export default {
  components: {
    contact,
    conductor,
    part4,
    part5,
    part6,
    part7,
    part8,
    part9,
    part10,
    part11,
    part12,
  },
  computed: {},
  data() {
    return {
      state: 2,
      files: "",
      fileUrl: "",
      dialogTableVisible: false,
      dialogVisible2: false,
      uploads: false,
      imports: false,
      dialogVisible: false,
      value: "",
      activityName: "",
      teamNum: "",
      basce: {
        teamChorusCh: "", // 团队合唱团中文名称
        teamChorusEn: "",
        teamPhoneCh: "", //团队电话中文
        teamPhoneEn: "",
        teamEmailCh: "", //团队电子邮箱
        teamEmailEn: "",
        teamNumCh: "", //团队人数
        teamNumEn: "",
        teamRegionNameCh: "", // 团队地区
        teamRegionNameEn: "",
        countryCh: "", //国家
        countryEn: "",
        streetCh: "", //住址
        streetEn: "",
        zipCh: "", //邮政编码
        zipEn: "",
        faxCh: "", //传真
        faxEn: "",
        websiteCh: "", //网址
        websiteEn: "",
        yearCh: "", //年份
        yearEn: "",
      },
      timee: 3,
      Contactperson: {
        type: 0,
        data: null,
      },
      Conductor: {
        type: 0,
        data: null,
      },
      conductors: {
        type: 0,
        data: null,
      },
      organizations: {
        type: 0,
        data: null,
      },
      Organizainfor: {
        type: 0,
        data: null,
      },
      Lengthstay: {
        type: 0,
        data: null,
      },
      numberrooms: {
        type: 0,
        data: null,
      },
      Transportation: {
        type: 0,
        data: null,
      },
      activities: {
        type: 0,
        data: null,
      },
      documents: {
        type: 0,
        data: null,
      },
      Scores: {
        type: 0,
        data: null,
      },
    };
  },

  created() {},
  mounted() {
    // this.getdeils();
    localStorage.setItem("states", 1);
  },
  methods: {
    //图片上传
    myUpload(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      upload(formData).then((res) => {
        if (res.code == 200) {
          this.$message.success("上传成功");
          this.fileUrl = res.data.fileUrl;
        }
      });
    },
    //查询用户已报名详情
    getdeils() {
      let data = {
        activityId: "123459",
      };
      apply_detail(data).then((res) => {
        this.basce.teamChorusCh = res.data.teamChorusCh;
        this.basce.teamChorusEn = res.data.teamChorusEn;
        this.basce.teamPhoneCh = res.data.teamPhoneCh;
        this.basce.teamPhoneEn = res.data.teamPhoneEn;
        this.basce.teamEmailCh = res.data.teamEmailCh;
        this.basce.teamEmailEn = res.data.teamEmailEn;
        this.basce.teamNumCh = res.data.teamNumCh;
        this.basce.teamNumEn = res.data.teamNumEn;
        this.basce.teamRegionNameEn = res.data.teamRegionNameEn;
        this.basce.teamRegionNameCh = res.data.teamRegionNameCh;
        this.basce.websiteCh = res.data.templateData.websiteCh;
        this.basce.websiteEn = res.data.templateData.websiteEn;
        this.basce.yearCh = res.data.templateData.yearCh;
        this.basce.yearEn = res.data.templateData.yearEn;
        this.basce.streetCh = res.data.templateData.streetCh;
        this.basce.streetEn = res.data.templateData.streetEn;
        this.basce.countryCh = res.data.templateData.countryCh;
        this.basce.countryEn = res.data.templateData.countryEn;
        this.basce.zipCh = res.data.templateData.zipCh;
        this.basce.zipEn = res.data.templateData.zipEn;
        this.basce.faxCh = res.data.templateData.faxCh;
        this.basce.faxEn = res.data.templateData.faxEn;

        this.Conductor = res.data.templateData.Conductor;
        this.Conductor.type = 1;
        this.Contactperson = res.data.templateData.Contactperson;
        this.Contactperson.type = 1;
        this.conductors = res.data.templateData.conductors;
        this.conductors.type = 1;
        this.organizations = res.data.templateData.organizations;
        this.organizations.type = 1;
        this.Organizainfor = res.data.templateData.Organizainfor;
        this.Organizainfor.type = 1;
        this.Lengthstay = res.data.templateData.Lengthstay;
        this.Lengthstay.type = 1;
        this.numberrooms = res.data.templateData.numberrooms;
        this.numberrooms.type = 1;
        this.Transportation = res.data.templateData.Transportation;
        this.Transportation.type = 1;
        this.activities = res.data.templateData.activities;
        this.activities.type = 1;
        this.documents = res.data.templateData.documents;
        this.documents.type = 1;
        this.Scores = res.data.templateData.Scores;
        this.Scores.type = 1;
      });
    },
    submits(states) {
      //获取联系人信息 Contact person

      this.Contactperson = this.$refs.Contactperson.contact;
      //获取指挥或艺术总监
      this.Conductor = this.$refs.Conductor.conductor;
      //获取我们的指挥在世界合唱比赛中还担任以下合唱团的指挥
      this.conductors = this.$refs.conductors.part4;
      //获取我们是下列组织的成员
      this.organizations = this.$refs.organizations.part5;
      //获取>组织信息
      this.Organizainfor = this.$refs.Organizainfor.part6;
      //获取停留时间
      this.Lengthstay = this.$refs.Lengthstay.part7;
      //获取选择住宿类型
      this.numberrooms = this.$refs.numberrooms.part8;
      //获取到达时乘坐的交通工具
      this.Transportation = this.$refs.Transportation.part9;

      //获取所要参加的活动总览
      this.activities = this.$refs.activities.part10;
      //获取同时提交下列文件
      this.documents = this.$refs.documents.part11;
      //获取同时提交歌谱
      this.Scores = this.$refs.Scores.part12;

      Object.keys(this.Transportation).map((item) => {
        if (!this.Transportation[item]) this.Transportation[item] = "";
      });
      if (!this.Transportation.airShuttle)
        this.Transportation.airShuttle = false;
      if (!this.Transportation.trainShuttle)
        this.Transportation.trainShuttle = false;
      if (!this.Transportation.otheShuttle)
        this.Transportation.otheShuttle = false;
      Object.keys(this.Contactperson).map((item) => {
        if (!this.Contactperson[item]) this.Contactperson[item] = "";
      });
      Object.keys(this.Conductor).map((item) => {
        if (!this.Conductor[item]) this.Conductor[item] = "";
      });
      if (!this.conductors.holdSendEmail) this.conductors.holdSendEmail = false;
      Object.keys(this.organizations).map((item) => {
        if (!this.organizations[item]) this.organizations[item] = "";
      });
      if (!this.organizations.foundationMember)
        this.organizations.foundationMember = false;
      if (!this.organizations.applyFoundationMember)
        this.organizations.applyFoundationMember = false;
      if (!this.organizations.discountMember)
        this.organizations.discountMember = false;
      if (!this.organizations.others) this.organizations.others = false;
      Object.keys(this.Organizainfor).map((item) => {
        if (!this.Organizainfor[item]) this.Organizainfor[item] = "";
      });
      Object.keys(this.Lengthstay).map((item) => {
        if (!this.Lengthstay[item]) this.Lengthstay[item] = "";
      });
      Object.keys(this.numberrooms).map((item) => {
        if (!this.numberrooms[item]) this.numberrooms[item] = "";
      });
      Object.keys(this.activities).map((item) => {
        if (!this.activities[item]) this.activities[item] = "";
      });
      if (!this.activities.activityChampion)
        this.activities.activityChampion = false;
      if (!this.activities.activityOpen) this.activities.activityOpen = false;
      if (!this.activities.activityComment)
        this.activities.activityComment = false;
      if (!this.activities.activityTutorial)
        this.activities.activityTutorial = false;
      if (!this.activities.activityConclude)
        this.activities.activityConclude = false;
      if (!this.activities.activityABDFriend)
        this.activities.activityABDFriend = false;
      if (!this.activities.activityFriend)
        this.activities.activityFriend = false;
      Object.keys(this.documents).map((item) => {
        if (!this.documents[item]) this.documents[item] = "";
      });
      if (!this.documents.activityRecord) this.documents.activityRecord = false;
      if (!this.documents.activitySynopsis)
        this.documents.activitySynopsis = false;
      if (!this.documents.activityPhoto) this.documents.activityPhoto = false;

      Object.keys(this.Scores).map((item) => {
        if (!this.Scores[item]) this.Scores[item] = "";
      });
      if (!this.Scores.activitySongChampion)
        this.Scores.activitySongChampion = false;
      if (!this.Scores.activitySongOpen) this.Scores.activitySongOpen = false;
      if (!this.Scores.activitySongComment)
        this.Scores.activitySongComment = false;
      if (!this.Scores.activitySongTutorial)
        this.Scores.activitySongTutorial = false;
      if (!this.Scores.activityVisacard) this.Scores.activityVisacard = false;
      if (!this.Scores.activityMastercard)
        this.Scores.activityMastercard = false;

      let data = {
        activityId: this.$route.query.value,
        fileUrl: this.fileUrl,
        state: states,
        teamInfoDto: {
          teamChorusCh: this.basce.teamChorusCh,
          teamChorusEn: this.basce.teamChorusEn,
          teamPhoneCh: this.basce.teamPhoneCh,
          teamPhoneEn: this.basce.teamPhoneEn,
          teamEmailCh: this.basce.teamEmailCh,
          teamEmailEn: this.basce.teamEmailEn,
          teamNumCh: this.basce.teamNumCh,
          teamNumEn: this.basce.teamNumEn,
          teamRegionNameCh: this.basce.teamRegionNameCh,
          teamRegionNameEn: this.basce.teamRegionNameEn,
        },
        template2Data: {
          baseInfo: {
            baseCountryCh: this.basce.baseCountryCh,
            baseCountryEn: this.basce.baseCountryEn,
            baseStreetCh: this.basce.baseStreetCh,
            baseStreetEn: this.basce.baseStreetEn,
            baseZipCh: this.basce.baseZipCh,
            baseZipEn: this.basce.baseZipEn,
            baseFaxCh: this.basce.baseFaxCh,
            baseFaxEn: this.basce.baseFaxEn,
            baseWebsiteCh: this.basce.baseWebsiteCh,
            baseWebsiteEn: this.basce.baseWebsiteEn,
            baseYearCh: this.basce.baseYearCh,
            baseYearEn: this.basce.baseYearEn,

            contactSex: this.Contactperson.contactSex,
            contactFirstNameCh: this.Contactperson.contactFirstNameCh,
            contactFirstNameEn: this.Contactperson.contactFirstNameEn,
            contactLastNameCh: this.Contactperson.contactLastNameCh,
            contactLastNameEn: this.Contactperson.contactLastNameEn,
            contactZipCh: this.Contactperson.contactZipCh,
            contactZipEn: this.Contactperson.contactZipEn,
            contactStreetCh: this.Contactperson.contactStreetCh,
            contactStreetEn: this.Contactperson.contactStreetEn,
            contactFaxCh: this.Contactperson.contactFaxCh,
            contactFaxEn: this.Contactperson.contactFaxEn,
            contactPhoneCh: this.Contactperson.contactPhoneCh,
            contactPhoneEn: this.Contactperson.contactPhoneEn,
            contactEmailCh: this.Contactperson.contactEmailCh,
            contactEmailEn: this.Contactperson.contactEmailEn,
            contactCityCh: this.Contactperson.contactCityCh,
            contactCityEn: this.Contactperson.contactCityEn,
            contactCityEn: this.Contactperson.contactCityEn,

            conductSex: this.Conductor.conductSex,
            conductFirstNameCh: this.Conductor.conductFirstNameCh,
            conductFirstNameEn: this.Conductor.conductFirstNameEn,
            conductLastNameCh: this.Conductor.conductLastNameCh,
            conductLastNameEn: this.Conductor.conductLastNameEn,
            conductStreetCh: this.Conductor.conductStreetCh,
            conductStreetEn: this.Conductor.conductStreetEn,
            conductCityEn: this.Conductor.conductCityEn,
            conductCityCh: this.Conductor.conductCityCh,
            conductZipCh: this.Conductor.conductZipCh,
            conductZipEn: this.Conductor.conductZipEn,
            conductPhoneCh: this.Conductor.conductPhoneCh,
            conductPhoneEn: this.Conductor.conductPhoneEn,
            conductFaxCh: this.Conductor.conductFaxCh,
            conductFaxEn: this.Conductor.conductFaxEn,
            conductEmailCh: this.Conductor.conductEmailCh,
            conductEmailEn: this.Conductor.conductEmailEn,

            holdChorusCh: this.conductors.holdChorusCh,
            holdChorusEn: this.conductors.holdChorusEn,
            holdSendEmail: this.conductors.holdSendEmail,
            fillAddresCh: this.conductors.fillAddresCh,
            fillAddresEn: this.conductors.fillAddresEn,
            fillDateCh: this.conductors.fillDateCh,
            fillDateEn: this.conductors.fillDateEn,
            holdNameEn: this.conductors.holdNameEn,
            holdNameCh: this.conductors.holdNameCh,
            holdSignatureCh: this.conductors.holdSignatureCh,
            holdSignatureEn: this.conductors.holdSignatureEn,

            foundationMember: this.organizations.foundationMember,
            discountMember: this.organizations.discountMember,
            applyFoundationMember: this.organizations.applyFoundationMember,
            others: this.organizations.others,
            foundationMemberCh: this.organizations.foundationMemberCh,
            foundationMemberEn: this.organizations.foundationMemberEn,
            discountMemberCh: this.organizations.discountMemberCh,
            discountMemberEn: this.organizations.discountMemberEn,
            othersCh: this.organizations.othersCh,
            othersEn: this.organizations.othersEn,
          },
          organizeInfo: {
            organizeChorusCh: this.Organizainfor.organizeChorusCh,
            organizeChorusEn: this.Organizainfor.organizeChorusEn,
            organizeCountCh: this.Organizainfor.organizeCountCh,
            organizeCountEn: this.Organizainfor.organizeCountEn,
            organizeTogetherCountCh: this.Organizainfor.organizeTogetherCountCh,
            organizeTogetherCountEn: this.Organizainfor.organizeTogetherCountEn,
            organizeCarCountCh: this.Organizainfor.organizeCarCountCh,
            organizeCarCountEn: this.Organizainfor.organizeCarCountEn,
            organizeTotalCountCh: this.Organizainfor.organizeTotalCountCh,
            organizeTotalCountEn: this.Organizainfor.organizeTotalCountEn,

            arrivalCh: this.Lengthstay.arrivalCh,
            arrivalEn: this.Lengthstay.arrivalEn,
            departureCh: this.Lengthstay.departureCh,
            departureEn: this.Lengthstay.departureEn,
            nightsCh: this.Lengthstay.nightsCh,
            nightsEn: this.Lengthstay.nightsEn,

            hotelType: this.numberrooms.hotelType,
            economicsTwoCh: this.numberrooms.economicsTwoCh,
            economicsTwoEn: this.numberrooms.economicsTwoEn,
            economicsAloneCh: this.numberrooms.economicsAloneCh,
            economicsAloneEn: this.numberrooms.economicsAloneEn,
            standardTwoCh: this.numberrooms.standardTwoCh,
            standardTwoEn: this.numberrooms.standardTwoEn,
            standardAloneCh: this.numberrooms.standardAloneCh,
            standardAloneEn: this.numberrooms.standardAloneEn,
            highTwoCh: this.numberrooms.highTwoCh,
            highTwoEn: this.numberrooms.highTwoEn,
            highAloneCh: this.numberrooms.highAloneCh,
            highAloneEn: this.numberrooms.highAloneEn,

            type: this.Transportation.type,

            airAddressCh: this.Transportation.airAddressCh,
            airAddressEn: this.Transportation.airAddressEn,
            airCompanyCh: this.Transportation.airCompanyCh,
            airCompanyEn: this.Transportation.airCompanyEn,
            airCodeCh: this.Transportation.airCodeCh,
            airCodeEn: this.Transportation.airCodeEn,
            airShuttle: this.Transportation.airShuttle,
            trainAddressCh: this.Transportation.trainAddressCh,
            trainAddressEn: this.Transportation.trainAddressEn,
            trainShuttle: this.Transportation.trainShuttle,
            otherAddressCh: this.Transportation.otherAddressCh,
            otherAddressEn: this.Transportation.otherAddressEn,
            otheShuttle: this.Transportation.otheShuttle,
            fillCityCountryCh: this.Transportation.fillCityCountryCh,
            fillCityCountryEn: this.Transportation.fillCityCountryEn,
            fillTableDateCh: this.Transportation.fillTableDateCh,
            fillTableDateEn: this.Transportation.fillTableDateEn,
            linkmanSignatureCh: this.Transportation.linkmanSignatureCh,
            linkmanSignatureEn: this.Transportation.linkmanSignatureEn,
            commandSignatureCh: this.Transportation.commandSignatureCh,
            commandSignatureEn: this.Transportation.commandSignatureEn,
          },
          activityOverview: {
            activityChorusCh: this.activities.activityChorusCh,
            activityChorusEn: this.activities.activityChorusEn,
            activityChampion: this.activities.activityChampion,
            activityOpen: this.activities.activityOpen,
            activityComment: this.activities.activityComment,
            activityTutorial: this.activities.activityTutorial,
            activityConclude: this.activities.activityConclude,
            activityABDFriend: this.activities.activityABDFriend,
            activityFriend: this.activities.activityFriend,

            activityRecord: this.documents.activityRecord,
            activitySynopsis: this.documents.activitySynopsis,
            activityPhoto: this.documents.activityPhoto,

            activitySongChampion: this.Scores.activitySongChampion,
            activitySongOpen: this.Scores.activitySongOpen,
            activitySongComment: this.Scores.activitySongComment,
            activitySongTutorial: this.Scores.activitySongTutorial,
            activityVisacard: this.Scores.activityVisacard,
            activityMastercard: this.Scores.activityMastercard,
            cardholderNameCh: this.Scores.cardholderNameCh,
            cardholderNameEn: this.Scores.cardholderNameEn,
            cardNumberCh: this.Scores.cardNumberCh,
            cardNumberEn: this.Scores.cardNumberEn,
            periodDateCh: this.Scores.periodDateCh,
            periodDateEn: this.Scores.periodDateEn,
            authCodeCh: this.Scores.authCodeCh,
            authCodeEn: this.Scores.authCodeEn,
            signatureCh: this.Scores.signatureCh,
            signatureEn: this.Scores.signatureEn,
            activityFillCityCh: this.Scores.activityFillCityCh,
            activityFillCityEn: this.Scores.activityFillCityEn,
            activityFillDateCh: this.Scores.activityFillDateCh,
            activityFillDateEn: this.Scores.activityFillDateEn,
            activityLinkmanCh: this.Scores.activityLinkmanCh,
            activityLinkmanEn: this.Scores.activityLinkmanEn,
            activityDirectorCh: this.Scores.activityDirectorCh,
            activityDirectorEn: this.Scores.activityDirectorEn,
          },
        },
      };
      console.log(data);
      applysubmit(data).then((res) => {
        if (res.code == 200) {
          if (data.state == 0) {
            this.dialogVisible2 = true;
            const TIME_COUNT = 3;
            let timer = setInterval(() => {
              if (this.timee > 0) {
                this.timee--;
              } else {
                this.dialogVisible2 = false;
                clearInterval(timer);
                timer = null;
              }
            }, 1000);
          } else {
            this.$message.success(res.msg);
            this.dialogTableVisible = false;
          }
        } else {
          this.$message.info(res.msg);
        }
      });
    },

    //模板2下载模板附件
    uploa() {
      let data = {
        type: 2,
      };
      template_file(data).then((res) => {
        window.location.href = res.data;
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .el-dialog {
      width: 560px;
      height: 330px;
      border-radius: 12px;
      margin: 0 !important;
      .el-dialog__header {
        background: #24558b;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;

        .el-dialog__title {
          color: white;
        }

        .el-dialog__headerbtn {
          i {
            color: white;
          }
        }
      }

      .el-dialog__body {
        p {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fc524c;
          line-height: 52px;
          text-align: center;
        }

        span {
          display: inline-block;
          width: 100%;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #24558b;
          line-height: 48px;
          text-align: center;
          margin-top: 54px;
        }

        .btnboxs {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 50px;

          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }

        .btnbox {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 20px;

          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }
      }
    }
  }

  .box {
    margin: auto;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    margin-bottom: 42px;

    .el-dialog__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/ .el-dialog {
        width: 560px;
        height: 330px;
        border-radius: 12px;
        margin: 0 !important;
        .el-dialog__header {
          background: #24558b;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;

          .el-dialog__title {
            color: white;
          }

          .el-dialog__headerbtn {
            i {
              color: white;
            }
          }
        }

        .el-dialog__body {
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fc524c;
            line-height: 118px;
            text-align: center;
          }

          span {
            display: inline-block;
            width: 100%;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #24558b;
            line-height: 48px;
            text-align: center;
            margin-top: 54px;
          }

          .btnbox {
            display: flex;
            justify-content: space-evenly;
            width: 59%;
            margin: auto;
            margin-top: 20px;

            button {
              width: 100px;
              height: 42px;
              background: #24558b;
              border-radius: 8px;
              color: #ffffff;
              margin: 0;
              padding: 0;
              border: 1px solid transparent; //自定义边框
              outline: none; //消除默认点击蓝色边框效果
              cursor: pointer;
            }

            .info {
              background: #ffffff;
              border: 1px solid #a6aab8;
              color: #838a9d;
            }
          }
        }
      }
    }

    .header {
      display: flex;
      justify-content: space-between;
      width: 90%;
      margin: 48px 48px;

      .title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3c4353;
      }
    }

    .cont {
      .bottoms {
        width: 100%;
        height: 132px;
        margin-top: 96px;
        box-shadow: 0px 0px 10px 0px rgba(8, 27, 42, 0.1);
        display: flex;
        justify-content: center;

        .el-button {
          height: 42px;
          margin-left: 50px;
          margin-top: 57px;
        }
      }
      .uploadform {
        display: flex;
        height: 60px;
        justify-content: space-between;
        padding-left: 100px;
        padding-right: 100px;
        margin-top: 20px;

        div {
          height: 60px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #167afc;
          line-height: 60px;
          cursor: pointer;
          /deep/ .el-upload-list {
            display: none;
          }
        }
      }
      .part1 {
        .texterar {
          div {
            width: 100%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-textarea {
              min-height: 200px;

              /deep/.el-textarea__inner {
                min-height: 200px !important;
              }
            }
          }
        }

        .listdiv {
          display: flex;
          justify-content: space-between;

          div {
            width: 30%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-input {
              width: 100%;
            }

            .el-select {
              width: 100%;
            }
          }
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;

          /deep/ .el-input-group__prepend {
            border-right: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
          }
        }

        li:nth-child(3) {
          margin-top: 30px;
        }

        li:nth-child(5) {
          margin-top: 30px;
        }

        li:nth-child(7) {
          margin-top: 30px;
        }

        li:nth-child(9) {
          margin-top: 30px;
        }

        li:nth-child(11) {
          margin-top: 30px;
        }
      }

      .part2 {
        .title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #3c4353;
          margin: 48px 48px;
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;

          /deep/ .el-input-group__prepend {
            border-right: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
          }

          .radiobox {
            width: 30%;
            border: 1px solid gainsboro;

            .el-radio {
              margin-left: 30px;
              margin-top: 14px;
            }
          }
        }

        li:nth-of-type(3) {
          margin-top: 30px;
        }

        li:nth-of-type(5) {
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
